import { useTranslation } from "react-i18next";

import { Panel, Tag } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import { MemberEligibilityInfo } from "@/App/types";
import { formatDate } from "capitalrx-utilities";
import { MemberDependent } from "@/App/api/member";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.patientDetails";
interface PatientClaimCard {
  readonly patient: MemberEligibilityInfo["member"] | MemberDependent;
  readonly isClaimPatient?: boolean;
}

export const DirectMemberReimbursementPatientDetailsCard = ({ patient, isClaimPatient = false }: PatientClaimCard) => {
  const { t: translate } = useTranslation();

  let address = "";
  if (patient?.address_line_1) {
    address += patient?.address_line_1 + ", ";
  }
  if (patient?.address_line_2) {
    address += patient?.address_line_2 + ", ";
  }
  if (patient?.address_line_3) {
    address += patient?.address_line_3 + ", ";
  }
  if (patient?.city) {
    address += patient?.city + ", ";
  }
  if (patient?.state) {
    address += patient?.state + ", ";
  }
  if (patient?.zip_code) {
    address += " " + patient?.zip_code;
  }

  return (
    <Panel appearance="primary" style={{ height: "100%" }}>
      <Stack>
        <Shelf alignment="top">
          <Stack spacing="none">
            { patient?.relationship_code === "1" && <Body style={{ color: "#60646D" }}><Semibold>{translate(`${TRANSLATION_PATH}.policyHolder`)}</Semibold></Body>}
            { patient?.relationship_code !== "1" && <Body style={{ color: "#60646D" }}><Semibold>{translate(`${TRANSLATION_PATH}.dependent`)}</Semibold></Body>}
            <Shelf spacing="small"><Semibold>{patient?.first_name} {patient?.last_name}</Semibold><Body size="medium">ID: {patient?.external_member_id}</Body></Shelf>
          </Stack>
          <Shelf.Spacer />
          {
            isClaimPatient && <Tag type="system">{translate(`${TRANSLATION_PATH}.patient`)}</Tag>
          }
        </Shelf>
        <Shelf alignment="top">
          <Stack spacing="mini">
            <Body style={{ color: "#60646D" }} size="small"><Semibold>{translate(`${TRANSLATION_PATH}.dateOfBirth`)}</Semibold></Body>
            <Body>{formatDate(patient?.birth_date, "MM/DD/YYYY")}</Body>
          </Stack>
          <Stack spacing="mini">
            <Body style={{ color: "#60646D" }} size="small"><Semibold>{translate(`${TRANSLATION_PATH}.address`)}</Semibold></Body>
            <Body>{address}</Body>
          </Stack>
          <Shelf.Spacer />
        </Shelf>
          {
            isClaimPatient && <Body size="small"><Semibold>{translate(`${TRANSLATION_PATH}.personSubmittingFor`)}</Semibold></Body>
          }
      </Stack>
    </Panel>
  );
};
